import type { DsFilter } from '../types';

/** Path-fragment families per filter. A topic matches if it contains any
 *  fragment. Tenant-agnostic (matches '/drones/' not 'airmarket/Drones'). */
const FAMILIES: Record<Exclude<DsFilter, 'all'>, string[]> = {
  aircraft: [
    '/aircraft/',
    '/drones/',
    'asset_tracking',
    'networkid',
    'traffic_control',
    'tisb',
    'dronesense',
  ],
  surveillance: ['surveillance_traffic', 'surveillance_sensors', 'tisb', '/live_'],
  traffic: ['traffic_control', 'tisb', 'surveillance_sensors', 'surveillance_traffic'],
  // Drone-scoped canonical v1 topics (FLYsafe MQTT Topic doc). The app
  // subscribes to these (see LEGACY_SUBSCRIPTIONS); they only carry data once a
  // drone is online, so the chip may match only the seeded placeholders.
  events: ['/events'],
  alerts: ['/alerts'],
  oi: ['/oi', '/declaration'],
};

/** Filters whose topics are strictly per-drone — used to explain an empty
 *  result as "waiting for a drone" rather than "no topic". Alerts is NOT here:
 *  `v1/output/alerts/{severity}` (ticket 86e2jbaqr Part 5/7) is tenant-wide,
 *  not drone-scoped, so an empty Alerts result isn't necessarily "no drone". */
export const DRONE_SCOPED_FILTERS: ReadonlySet<DsFilter> = new Set<DsFilter>(['events', 'oi']);

export function topicMatchesFilter(topic: string, filter: DsFilter): boolean {
  if (filter === 'all') return true;
  const fragments = FAMILIES[filter];
  if (!fragments) return true;
  const t = topic.toLowerCase();
  return fragments.some((frag) => t.includes(frag));
}
